

const actions = {
    openMobileMenu(vuexContext) {
        vuexContext.commit('setOpenedMobileMenu', true);
    },
    closeMobileMenu(vuexContext) {
        vuexContext.commit('setOpenedMobileMenu', false);
    }
};

export default actions;